function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import { initProductData } from './flavorSelector/index';
var _window$bt = window.bt,
    _window$bt$lil = _window$bt.lil;
_window$bt$lil = _window$bt$lil === void 0 ? {} : _window$bt$lil;
var _window$bt$lil$freeIt = _window$bt$lil.freeItems,
    freeItems = _window$bt$lil$freeIt === void 0 ? {} : _window$bt$lil$freeIt,
    _window$bt$lil$offerC = _window$bt$lil.offerCYPs,
    offerCYPs = _window$bt$lil$offerC === void 0 ? [] : _window$bt$lil$offerC,
    _window$bt$product = _window$bt.product;
_window$bt$product = _window$bt$product === void 0 ? {} : _window$bt$product;
var defaultProduct = _window$bt$product.data; // default free reports for all CYP options

var freeReportsToAdd = Object.entries(freeItems).filter(function (_ref) {
  var _ref2 = _slicedToArray(_ref, 2),
      value = _ref2[1];

  return value > 0;
}).map(function (_ref3) {
  var _ref4 = _slicedToArray(_ref3, 2),
      key = _ref4[0],
      value = _ref4[1];

  return toFreeReportLineItem(key, value);
});

function toFreeReportLineItem(variantId, quantity) {
  return {
    quantity: quantity,
    merchandiseId: "gid://shopify/ProductVariant/".concat(variantId)
  };
}

offerCYPs.forEach(function (cyp) {
  var _cyp$freeReportIds;

  if (cyp.product || defaultProduct) {
    cyp.product = initProductData(cyp.product || defaultProduct);
  } else {
    cyp.product = {};
    console.warn('Missing product data!');
  }

  if (cyp !== null && cyp !== void 0 && (_cyp$freeReportIds = cyp.freeReportIds) !== null && _cyp$freeReportIds !== void 0 && _cyp$freeReportIds.length) {
    cyp.freeReports = cyp.freeReportIds.map(function (variantId) {
      return toFreeReportLineItem(variantId, 1);
    });
  } else {
    cyp.freeReports = freeReportsToAdd;
  }
});
export function getOfferCYPs() {
  return offerCYPs;
}